// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2162": "50116afa419c","2530": "e96a97f91d26","5257": "88225f65dff9","8047": "7acf0ebfa2b4",}[chunkId] + ".css"
}